import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
} from '@angular/core';
import { KingNewService } from './king-new.service';
import { KingQueueComponent } from './components/king-queue/king-queue.component';
import { KingTimerComponent } from './components/king-timer/king-timer.component';
import { KingSideTopComponent } from './components/king-side-top/king-side-top.component';
import { KingSideBottomComponent } from './components/king-side-bottom/king-side-bottom.component';
import { FairnessButtonComponent } from '@core/components/fairness-button/fairness-button.component';
import { GameIconComponent } from '@core/components/game-icon/game-icon.component';
import { ModalService } from '@features/modals/services/modal.service';
import { KingRowComponent } from './components/king-row/king-row.component';
import { ClipboardService } from '@core/services/clipboard.service';

@Component({
  selector: 'app-king-new',
  templateUrl: './king-new.component.html',
  styleUrls: ['./king-new.component.scss'],
  standalone: true,
  imports: [
    KingQueueComponent,
    KingTimerComponent,
    KingSideTopComponent,
    KingSideBottomComponent,
    FairnessButtonComponent,
    GameIconComponent,
    KingRowComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KingNewComponent implements OnDestroy {
  public readonly kingService = inject(KingNewService);
  public readonly clipboardService = inject(ClipboardService);
  private readonly modalService = inject(ModalService);

  constructor() {
    // Reset only animation state, not game data (socket events keep game data updated)
    this.kingService.resetAnimationState();
    // Request current game state to ensure we're in sync
    this.kingService.requestGameState();
  }

  ngOnDestroy(): void {
    // Clean up animation state when leaving the page
    this.kingService.resetAnimationState();
  }

  openDepositModal() {
    this.modalService.openModal('DepositKingModal');
  }
}
